import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './scss/index.scss';
import App from './App';
import { store } from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    {/*<Provider store={store}>*/}
    <App />
    {/*</Provider>*/}
  </BrowserRouter>
);
